import PropTypes from 'prop-types'

/**
 * @typedef {Object} ObjectFeatureQuota
 * @property {string} [featureName] - The feature name, taken from the FeatureType enum
 * @property {number} [maxQuota] - The maximum available quota
 * @property {number} [usedQuota] - The currently used quota
 */
export const objectFeatureQuotaPropType = PropTypes.shape({
    featureName: PropTypes.string,
    maxQuota: PropTypes.number,
    usedQuota: PropTypes.number
})
